/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_PrepaidInputs */

const vi_customer_debt_ledger_prepaid = /** @type {(inputs: Customer_Debt_Ledger_PrepaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả trước`)
};

/**

* @param {Customer_Debt_Ledger_PrepaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_prepaid = /** @type {((inputs?: Customer_Debt_Ledger_PrepaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_PrepaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_prepaid(inputs)
});